<template>
	<div class="tw-relative">
		<div class="tw-mt-1 tw-flex tw-space-x-2">
			<div class="tw-flex-1">
				<location-picker-autocomplete :value="mValue.name" @placechanged="onChangePlace" />
			</div>
			<b-button
				v-if="expandedModal"
				@click="onInitExpandedModal"
				variant="outline-primary"
				class="tw-border-gray-300 tw-h-11 tw-w-11 tw-p-1 tw-flex-none"
			>
				<i class="fas fa-expand-arrows-alt"></i>
			</b-button>
		</div>
		<gmap-map
			id="map"
			ref="mapRef"
			:zoom="mZoom"
			:center="mCenter"
			@click="handleChangeMarker"
			:map-type-id="'roadmap'"
			class="tw-w-full tw-mt-2 tw-rounded tw-overflow-hidden"
			:style="{
				height: mapHeight,
				featureType: 'poi',
				elementType: 'labels',
				stylers: [
					{ visibility: 'off' }
				]
			}"
			:options="{
				zoomControl: false,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				disableDefaultUi: true
			}"
		>
			<gmap-marker draggable v-if="value.lat" :position="value" @dragend="handleChangeMarker"></gmap-marker>
		</gmap-map>

		<b-modal
			v-if="expandedModal"
			centered
			size="xl"
			header-class="tw-text-xl"
			cancel-title="Cancelar"
			ok-title="Seleccionar Ubicación"
			body-class="tw-py-0"
			v-model="expanded.modal"
			@hide="onResetExpanded"
		>
			<template #modal-title>
				<strong class="tw-text-xl">Seleccionar Ubicación</strong>
			</template>
			<location-picker v-model="mValue" map-height="65vh"></location-picker>
		</b-modal>
	</div>
</template>

<script>
import { sleep } from '../helpers'
import { gmapApi } from 'vue2-google-maps'
import LocationPickerAutocomplete from './LocationPickerAutocomplete.vue'
export default {
	name: 'LocationPicker',
	components: {
		LocationPickerAutocomplete,
	},
	props: {
		flat: Boolean,
		multiple: Boolean,
		outlined: Boolean,
		searchLabel: String,
		mapHeight: {
			default: '284px',
			type: [String, Number],
		},
		zoom: {
			default: 14,
			type: [String, Number]
		},
		center: {
			type: Object,
			default: () => ({
				lat: 23.7579665,
				lng: 90.3954495
			})
		},
		value: {
			type: [Object, Array],
			required: true,
			default: () => ({
				lat: null,
				lng: null
			})
		},
		expandedModal: Boolean
	},
	data: () => ({
		map: null,
		mZoom: null,
		mCenter: {
			lat: 23.7579665,
			lng: 90.3954495
		},
		expanded: {
			modal: false
		}
	}),
	mounted() {
		this.$refs.mapRef.$mapPromise.then(map => {
			this.map = map
			this.geocoder = new this.google.maps.Geocoder()
		})
	},
	computed: {
		google: gmapApi,
		mValue: {
			get() { return this.value },
			set(v) { this.$emit('input', v) }
		},
	},
	watch: {
		zoom: {
			immediate: true,
			handler(zoom) {
				this.mZoom = zoom
			}
		},
		// center: {
		// 	deep: true,
		// 	immediate: true,
		// 	handler(center) {
		// 		if (
		// 			center.lat !== this.mCenter.lat ||
		// 			center.lng !== this.mCenter.lng
		// 		) {
		// 			this.mCenter = { ...center }
		// 		}
		// 	}
		// },
		value: {
			deep: true,
			immediate: true,
			handler(v) {
				if (!v.lat || !v.lng || !this.map) return
				this.map.panTo(v)
				this.mZoom = 14
				setTimeout(() => {
					this.mCenter = {
						lat: v.lat, lng: v.lng
					}
				}, 500);
			}
		}
	},
	methods: {
		onResetExpanded() {
			this.expanded.modal = false
		},
		onInitExpandedModal() {
			this.expanded.modal = true
		},
		async handleChangeMarker(e) {
			let location = {
				lat: e.latLng.lat(),
				lng: e.latLng.lng()
			}
			let [err, res] = await this.onGetGeoCode(e.latLng)
			if (!err) location = { ...location, ...res }
			this.mValue = { ...location }
		},
		async useCurrentLocation() {
			let [err, location] = await this.getCurrentLocation()
			if (!err) {
				this.mValue = { ...location }
				this.map.panTo(location)
				this.mZoom = 14
			}
		},
		findGeoAddress(addresses, keyword) {
			let address = addresses.find(
				addr => addr.types.includes(keyword)
			)
			if (!address) return null
			return address.long_name
		},
		onGetGeoCode(latLng) {
			return new Promise(resolve => {
				return this.geocoder.geocode({ latLng }, (results, status) => {
					if (status === this.google.maps.GeocoderStatus.OK) {
						let location = {
							lat: results[0].geometry.location.lat(),
							lng: results[0].geometry.location.lng(),
							name: results[0].formatted_address,
							country: this.findGeoAddress(results[0].address_components, 'country'),
							locality: this.findGeoAddress(results[0].address_components, 'locality')
						}
						return resolve([false, location])
					}
					return resolve([true, null])
				});
			})
		},
		onChangePlace(e) {
			this.mValue = {
				name: e.name,
				lat: e.latitude,
				lng: e.longitude,
				country: e.country,
				locality: e.locality,
			}
		},
		getAreaAddress(addresses, keyword) {
			let address = addresses.find(
				addr => addr.types.includes(keyword)
			)
			if (!address) return null
			return address.long_name
		},
		getCurrentLocation() {
			return new Promise(resolve => {
				navigator.geolocation.getCurrentPosition(async position => {
					const { latitude, longitude } = position.coords
					let location = { lat: latitude, lng: longitude }
					let [err, locationInfo] = await this.getLocationInfo(location)
					if (!err) location = { ...location, ...locationInfo }
					return resolve([false, location])
				}, error => {
					console.log('navigator.geolocation.getCurrentPosition', error)
				})
			})
		},
		getGoogle() {
			return new Promise(resolve => {
				let get = async () => {
					if (this.google) {
						return (resolve(this.google))
					}
					await sleep(500)
					get()
				}
				get()
			})
		},
		async getLocationInfo(latLng) {
			let google = this.google || await this.getGoogle()
			return new Promise(resolve => {
				return new google.maps.Geocoder().geocode({ latLng }, (results, status) => {
					if (status === google.maps.GeocoderStatus.OK) {
						let location = {
							lat: results[0].geometry.location.lat(),
							lng: results[0].geometry.location.lng(),
							name: results[0].formatted_address,
							country: this.getAreaAddress(results[0].address_components, 'country'),
							locality: this.getAreaAddress(results[0].address_components, 'locality')
						}
						return resolve([false, location])
					}
					return resolve([true, null])
				});
			})
		},
	}
}
</script>
